import { Styles, css, extractTransition, withStyles } from '@recruit-robin/robin-theme/web-styles';

const styles = {
  pill: ({ theme }) => css`
    display: inline-flex;
    align-items: center;
    gap: 4px;
    height: 26px;
    padding-left: 6px;
    padding-right: 9px;
    background-color: ${theme.colors.neutral.variant[10]};
    border-radius: 12px;
    cursor: default;

    ${extractTransition((f) => f.cubic, { property: 'background-color', duration: 220 })}

    &:hover {
      background-color: ${theme.colors.neutral.variant[20]};
    }
  `,
  pillOpen: ({ theme }) => css`
    background-color: ${theme.colors.neutral.variant[20]};
  `,
  radio: css`
    background: white;
    border-radius: 50%;
  `,
  group: css`
    display: flex;
    flex-wrap: wrap;
    gap: 6px 6px;
  `,
  dropdownMenu: css`
    z-index: 3;
    cursor: default;
    max-width: 300px;
  `,
  dropdownMenuInputContainer: ({ theme }) => css`
    padding: 12px 16px;
    width: 100%;

    border-bottom: 1px solid ${theme.colors.neutral.variant[10]};
  `,
  dropdownMenuHeader: css`
    padding-top: 12px;
    padding-left: 16px;
    padding-bottom: 4px;
  `,
} satisfies Styles<void>;

export const useStyles = withStyles(styles);
